module.exports = __webpack_public_path__ + "static/media/cad.e61e2bd3.png";